import { AxiosRequestConfig } from 'axios';
import { CardLimitInterface } from 'constants/card';
import { InvoiceInterface, InvoicePurchases } from 'constants/invoice';

interface ValuesMapper {
  'invoice/current': InvoiceInterface;
  'auth/callback': Record<string, unknown>;
  limits: CardLimitInterface;
  'invoices/12/purchases': InvoicePurchases[];
}

const urlValuesMapper: ValuesMapper = {
  'invoice/current': {
    itauTimezone: 'America/Sao_Paulo',
    id: 20201122,
    closingInvoiceDate: '2020-11-10T00:00:00.000-03:00',
    value: 5703.38,
    dueDate: '2020-11-22T00:00:00.000-03:00',
    bestBuyingDate: '2020-12-11T00:00:00.000-03:00',
    status: 'Atual',
    installmentPurchasesTotal: 17149.27,
    nationalPurchasesTotal: 3469.39,
    internationalPurchasesTotal: 0,
    statusPayment: 'Fechada',
    cardDigits: '7107',
    previousInvoiceValue: 53697.87,
    iofTotal: 0,
    totalForeignWithdraw: 0,
    chargesAndServices: 9047.12,
    topPurchases: [
      {
        itauTimezone: 'America/Sao_Paulo',
        description: 'PARC C/JRS R$ ROBO11/12',
        date: '2019-12-24T00:00:00.000-03:00',
        origin: 'NATIONAL',
        priceReais: 49.88,
        howManyInstallments: 12,
        fullPriceReais: 684
      },
      {
        itauTimezone: 'America/Sao_Paulo',
        description: 'PARC S/JRS R$ ROBO11/24',
        date: '2019-12-24T00:00:00.000-03:00',
        origin: 'NATIONAL',
        priceReais: 420,
        howManyInstallments: 24,
        fullPriceReais: 11520
      },
      {
        itauTimezone: 'America/Sao_Paulo',
        description: 'PARC C/JRS R$ ROBO11/12',
        date: '2019-12-24T00:00:00.000-03:00',
        origin: 'NATIONAL',
        priceReais: 49.88,
        howManyInstallments: 12,
        fullPriceReais: 639.96
      },
      {
        itauTimezone: 'America/Sao_Paulo',
        description: 'PARC S/JRS R$ ROBO11/24',
        date: '2019-12-24T00:00:00.000-03:00',
        origin: 'NATIONAL',
        priceReais: 420,
        howManyInstallments: 24,
        fullPriceReais: 10800
      },
      {
        itauTimezone: 'America/Sao_Paulo',
        description: 'PARC C/JRS R$ ROBO10/12',
        date: '2020-01-21T00:00:00.000-03:00',
        origin: 'NATIONAL',
        priceReais: 53.75,
        howManyInstallments: 12,
        fullPriceReais: 667.2
      }
    ]
  },
  'auth/callback': {
    token: 'USE_MOCK'
  },
  limits: {
    totalLimit: 1000,
    availableLimit: 700,
    totalForeignWithdrawal: 0,
    availableForeignWithdrawal: 36810.63,
    availableWithdrawalLimit: 36810.63,
    totalWithdrawalLimit: 0,
    isFlexible: false,
    percentageBarValue: 0,
    cardDigits: '8707'
  },
  'invoices/12/purchases': [
    {
      itauTimezone: 'America/Sao_Paulo',
      description: 'PARC C/JRS R$ ROBO',
      date: '2020-08-17T00:00:00.000-03:00',
      origin: 'NATIONAL',
      priceReais: 52.35,
      howManyInstallments: 12,
      fullPriceReais: 628.2
    },
    {
      itauTimezone: 'America/Sao_Paulo',
      description: 'PARC S/JRS R$ ROBO',
      date: '2020-08-17T00:00:00.000-03:00',
      origin: 'NATIONAL',
      priceReais: 440,
      howManyInstallments: 24,
      fullPriceReais: 10560
    }
  ]
};

export async function get<T>(
  url: keyof ValuesMapper,
  config?: AxiosRequestConfig
): Promise<{ data: T }> {
  console.warn('Trying api-mock', url, config);
  await new Promise(resolve => setTimeout(resolve, 2000));
  return new Promise(resolve => {
    resolve({ data: urlValuesMapper[url] as T });
  });
}
